module.exports = __webpack_public_path__ + "img/Reactive_Power_Import_Total.2c05200c.jpeg";